import { DialogElement } from 'theme';

class WarrantyModal extends DialogElement {
  connectedCallback() {
    super.connectedCallback();

    this.querySelector('.warranty-modal__backdrop')?.addEventListener('click', () => this.hide(), {
      signal: this._abortController.signal,
    });
  }

  get shouldLock() {
    return true;
  }

  get shouldAppendToBody() {
    return true;
  }

  get initialFocus() {
    return this.querySelector('.warranty-modal__close');
  }

  _showTransition(animate = true) {
    this.style.display = 'flex';

    return this.animate([{ opacity: 0 }, { opacity: 1 }], { duration: animate ? 200 : 0, fill: 'forwards' }).finished;
  }

  _hideTransition() {
    return this.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150, fill: 'forwards' }).finished.then(() => {
      this.style.display = 'none';
    });
  }
}

if (!window.customElements.get('warranty-modal')) {
  window.customElements.define('warranty-modal', WarrantyModal);
}
